import { Component, OnInit } from '@angular/core';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { ApiService } from '../../services/api.service';

@Component({
  	selector: 'app-forgot-password',
  	templateUrl: './forgot-password.component.html',
  	styleUrls: ['./forgot-password.component.css']
})

export class ForgotPasswordComponent implements OnInit {
	
	private toasterService: ToasterService;
	username = "";
	msg = "";
	checkotp = false;
	otp = "";
	error_username = "";
	error_otp = "";
	
	constructor(private apiService: ApiService, toasterService: ToasterService) {
		this.toasterService = toasterService;
	}

	ngOnInit() {
		localStorage.setItem('temp_username', '');
		localStorage.setItem('temp_otp', '');
	}

	forgetPassword() {
		if (this.username == "") {
			this.error_username = "required";
		} else {
			this.error_username = "";
		}

		if (this.username != "") {
			this.apiService.forgetPassword(this.username).subscribe((data:any) => {
				this.checkotp = true;
				this.toasterService.pop('success', data.message);
			},
			error => {
				if(error.statusText ==  "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else {
					this.checkotp = false;
					 this.toasterService.pop('error', error.error.message);
				}
			});
		}
	}

	resendOtp() {
		if (this.username == "") {
			this.error_username = "required";
		} else {
			this.error_username = "";
		}

		if (this.username != "") {
			this.apiService.resendOTP(this.username).subscribe((data:any) => {
				// console.log('data===>', JSON.stringify(data), '--data');
				this.toasterService.pop('success', data.message);
			},
			error => {
				if(error.statusText ==  "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
		}
	}

	submitOtp() {
    	if (this.username == "") {
			this.error_username = "required";
    	} else {
			this.error_username = "";
    	}

		if (this.otp == "") {
			this.error_otp = "required";
		} else {
			this.error_otp = "";
		}

		if (this.username != "" && this.otp != "") {
			this.apiService.checkOtp(this.username, this.otp).subscribe((data:any) => {				
				this.checkotp = true;
				this.toasterService.pop('success', data.message);
				sessionStorage.setItem('change_password_token', data.data.accessToken);
				localStorage.setItem('temp_username', this.username);
				localStorage.setItem('temp_otp', this.otp);
				window.open("/changepassword", "_self");
			},
			error => {
				this.otp = '';
				if(error.statusText ==  "Unauthorized") {
					// this.toasterService.pop('error', 'Session Expired', 'Please login again');
					window.open("/logout", "_self");
				} else
					 this.toasterService.pop('error', error.error.message);
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/forgot-password/forgot-password.component.ts